<template>
    <div>
        <div v-if="modelValue" class="bg-overlay"></div>
        <transition name="fade">
            <div v-if="modelValue" class="custom-modal">
                <div class="modal-heading-container">
                    <div class="modal-heading">
                        <span data-testid="lblAlertTitle" v-if="modalMode === 'add'"
                            >Add ontop package?</span
                        >
                        <span data-testid="lblAlertTitle" v-else>Delete ontop the package?</span>
                    </div>
                    <button
                        class="el-icon-close btn-close"
                        data-testid="btnClose"
                        @click="onCloseModalWindowClick"
                    ></button>
                </div>
                <div class="modal-description-container">
                    <i class="el-icon-warning"></i>
                    <div class="modal-description">
                        <span data-testid="lblAlertMessage" v-if="modalMode === 'add'"
                            >Are you sure? Add on top package for this
                            member</span
                        >
                        <span data-testid="lblAlertMessage" v-else
                            >Are you sure? Remove this on-top package</span
                        >
                    </div>
                </div>
                <div class="modal-btn-container">
                    <el-button
                        data-testid="btnCancelAlert"
                        @click="onCloseModalWindowClick"
                        >Cancel</el-button
                    >
                    <slot name="btn-confirm"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'ModalAddOntopPackage',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        modalMode: {
            type: String
        }
    },
    methods: {
        onCloseModalWindowClick () {
            this.$emit('update:modelValue', false)
        }
    }
}
</script>

<style lang="scss">
.bg-overlay{
    background-color: #0000004d;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    top: 0;
    left: 0;
    z-index: 2004;
}

.custom-modal{
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);

    border: 1px solid #dddddd;
    border-radius: 4px;
    background: #ffffff;

    padding: 20px;

    width: 450px;
    z-index: 3000;

    box-shadow: 5px 5px 19px 0px rgba(0,0,0,0.75);

    .modal-heading-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .modal-heading{
            color: #303133;
            font-size: 18px;
            text-align: left;
        }

        .btn-close {
            border: none;
            background-color: transparent;
            font-size: 16px;
            cursor: pointer;
        }
    }

    .modal-description-container{
        display: flex;
        align-items: center;

        .modal-description{
            font-size: 14px;
            color: #606266;
        }

        i{
            color: #E57470;
            font-size: 24px;
            margin-right: 10px;
        }
    }

    .modal-btn-container{
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
